<template>
  <div>
    <div class="terms_and_conditions">
      <p>
        個人情報保護に関する当社の基本方針<br />
        当社は、個人情報の取扱いに関し、その情報を安全に管理し、適正に使用することの重要性から、以下のとおり「個人情報保護方針」を定め、当社で保有するすべての個人情報の保護に万全を尽くしてまいります。
      </p>

      <strong>■ 個人情報保護方針</strong>
      <p>
        1.当社は、個人情報を尊重し、個人情報の保護に関する法令、ガイドライン等を遵守いたします。<br />
        2.当社は、お客様からの個人情報を所定の目的以外には利用いたしません。また、個人信用情報機関から得たお客様の個人情報は、ご本人様の返済能力調査以外の目的には利用いたしません。<br />
        3.当社は、お客様との契約に際して取得する個人情報の利用目的については、書面（個人情報取扱同意書）によって、お客様ご本人様の同意を頂くこととします。<br />
        4.当社は、保有する個人情報を、「個人情報保護規程」等に基づき厳重に管理し、不正なアクセス又は、紛失、滅失、破壊、改ざん、漏えい等の防止に努め、安全管理措置を講じます。<br />
        5.当社は、お客様から当社の保有個人データの開示、訂正、利用停止等を求められたときは、速やかに対応いたします。また、お客様の相談窓口を設け、お客様からの個人情報に関する苦情や相談には誠実に対応いたします。<br />
        6.当社は、個人情報保護のためのマネジメントシステムを各種法令及び社会情勢の変化などに常に対応したものとするため、原則、年１回以上実施する監査結果に基づき随時必要な見直しを行い、継続的な改善を行います。
      </p>

      <p class="text-right">
        株式会社リバティー<br />
        代表取締役社長 福原 良佐<br />
        令和２年１０月２３日制定
      </p>

      <strong>■ 利用目的</strong>
      <p>
        当社の取得又は保有する個人情報は、次の目的に利用させていただきます。<br />
        ・商品及びサービスの案内<br />
        ・市場調査、分析及び商品、サービスの研究ならびに開発<br />
        ・本人確認、ユーザー認証<br />
        ・ユーザーのトラフィック測定および行動測定<br />
        ・広告の配信およびその成果確認<br />
        ・本サービスに関する規約変更など重要な通知の実施<br />
        ・アンケート調査<br />
        ・抽選結果・景品送付<br />
        ・官公庁への届け出、報告<br />
        ・当該ご請求への対応・本サービスに関するご案内・お問い合わせへの対応<br />
        ・その他当社が提供する各種サービスにおいて定める目的・サービス提供向上
      </p>

      <strong>■ 個人情報の第三者提供</strong>
      <p>
        当社は、お客様ご本人様の承諾を得ることなく個人情報を第三者に提供することは基本的にいたしません。但し、当社の業務委託先に対し個人情報の取扱いを委託する場合があります。この場合は、委託先においても、個人情報の適切な管理が行われるよう委託契約を締結し必要に応じて監査を実施する等の適切な措置を講じます。
      </p>

      <strong>■ 個人情報の開示</strong>
      <p>
        当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、お客様ご本人からのご請求であることを確認のうえで、お客様に対し、遅滞なく開示を行います。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。<br />
        なお、具体的な個人情報の開示の申出先、手続、手数料につきましては、「個人情報の開示、訂正、追加、削除について」をご覧ください。
      </p>

      <strong>■ 個人情報の訂正および利用の停止等</strong>
      <p>
        （１）当社は、お客様から、個人情報の内容が事実ではなく、訂正・追加・削除（以下「訂正等」という）を求められたときは、お客様ご本人からのご請求であることを確認のうえ遅滞なく調査を行い、その結果に基づき、弊社の定める方法に従って個人情報の内容の訂正等を行い、その旨をお客様に通知します。<br />
        （２）当社は、お客様から、以下の各号の理由に基づき個人情報の利用の停止または消去（以下「利用の停止等」という）を求められたときは、お客様ご本人からのご請求であることを確認のうえ遅滞なく調査を行い、その結果に基づき、個人情報の利用の停止等を行い、その旨をお客様に通知します。<br />
        ①あらかじめ公表された利用目的の範囲を超えて個人情報が取扱われているという理由<br />
        ②偽りその他の手段により個人情報が取得されたものであるという理由<br />
        （３）個人情報保護法その他の法令により、当社が訂正等または利用の停止等の義務を負わない場合、本条１項、２項の定めは適用されません。
      </p>

      <strong>■ お問合せ窓口</strong>
      <p>
        当社のプライバシーポリシーに関する、ご意見、ご質問、苦情の申出その他ユーザー情報の取扱いに関するお問い合わせは、以下の窓口にご連絡ください。<br />
        【サポートセンター】<br />
        TEL： サポートセンター電話番号［受付時間 9：00～18：00（平日のみ）］
      </p>

      <strong>■改定</strong>
      <p>
        当社は、当社の裁量に基づいて、本ポリシーを変更します。但し、個人情報保護法その他の法令により、改定に必要な手続が定められている場合には、当該法令に基づき改定を行うものとします。なお、当社は、お客様に対して本ポリシーを変更する場合には、変更後の本ポリシーの施行時期および内容を以下の方法で周知します。<br />
        ・当社のウェブサイトへの掲示<br />
        ・お客様への通知<br />
        ・その他適切な方法
      </p>

      <!-- <strong>【ご利用規約】</strong>
      <p>
        本規約は、株式会社リバティー（以下「弊社」といいます）の運営する施設およびWEBサイト（以下「本サービス」という）の利用条件について定めるものです。
      </p>

      <strong>第1条(会員資格)</strong>
      <p>
        入会は以下の規約に同意いただき、所定の会員登録手続きを完了された方といたします。
      </p>

      <strong>第2条(基本合意)</strong>
      <p>
        本サービスの利用については会員の責任となります。また、会員は本規約を承諾したうえで本サービスを利用するものとします。弊社が本サービス通じて随時会員に向けて発表する諸規定は、本規約の一部を構成し、会員はこれを承諾したうえで本サービスを利用するものとします。この規約は任意に変更することがあり、変更後に本サービスの利用があった場合には、会員はこの変更を承諾したものとします。<br />
      </p>

      <strong>第3条(会員)</strong>
      <p>
        1.弊社所定の登録手続きから氏名・生年月日・電話番号・メールアドレス・会員が任意に設定するパスワードなど(以下「会員情報」といいます)を弊社の定める方法に従って登録された方を会員とします。<br />
        2.会員は、登録した会員情報が真実であることを保証するものとし、弊社は、会員情報に基づいてのみ本サービスの利用を承諾するものとします。<br />
        3.次に該当する場合は、会員となることはできず、会員登録終了後においても、弊社の判断で会員資格を喪失することがあります。<br />
        (1)会員が実在しない場合<br />
        (2)過去に本規約違反などにより、会員資格の停止又は取消しが行われている場合<br />
        (3)会員情報に、虚偽の記載、誤記、又は記入漏れがあった場合<br />
        (4)弊社の業務の遂行上又は技術上支障がある場合<br />
        (5)会員が本規約に違反した場合<br />
        (6)その他、弊社が会員であることを不適当と判断した場合<br />
        4.弊社が会員に連絡、通知する場合、会員情報に登録された電話番号への連絡、メールアドレスへの送信をもって到達したものとみなします。
      </p>

      <strong>第4条(個人情報の利用目的)</strong>
      <p>
        ご登録頂いた個人情報は弊社内で共有し、ご挨拶や弊社提供の特典情報および宿泊プラン、通信販売等の新商品のご案内や、各種関連商品の販売、勧誘、広告及び宣伝物の送付、送信（電子メールを含む。）、ご案内、弊社内部における市場調査及び分析並びに商品及びアフターサービスの研究、開発及び実施のために利用いたします。
      </p>

      <strong>第5条(会員情報の取扱い)</strong>
      <p>
        1.本条にいう会員情報とは、ご登録いただいた個人情報、会員もしくは会員の代表者個人に関する氏名（フリガナを含む）、住所、電話番号、生年月日、ご職業、メールアドレス、クレジットカード情報、取引履歴、弊社に対して発生する料金の支払状況、その他届け出た情報とします。<br />
        2.本規約による義務の履行または権利行使のために、弊社は会員情報を保存し管理するものとします。<br />
        3.弊社は、本条第2項及び以下の各号に定める場合を除いて、第三者に対し会員情報の開示を行わないものとします。<br />
        (1)会員が同意する場合<br />
        (2)弊社が実施する懸賞に当選した会員に関して、当選者の氏名及び住所の存する都道府県名を公表する場合<br />
        (3)法令により開示が求められた場合<br />
        (4)本サイト上での会員の行為が、法令または利用規約等に反し、弊社の権利、財産が侵害されるおそれがある場合や、本サービスの提供に支障があると認められる場合<br />
        (5)裁判所、検察官、警察、弁護士会、消費者センターまたはこれに準じた権限を有する機関から、会員の登録内容についての開示が求められた場合<br />
        4.弊社は、会員情報の管理には最大限の努力を払いますが、万が一、第三者による故意のハッキング等により生じた情報漏洩やこれに伴い会員に生じた損害すべてに対し、いかなる責任も負わないものとします。
      </p>

      <strong>第6条(会員情報の開示・訂正・削除等)</strong>
      <p>
        弊社の定める方法に従い、会員から会員情報の利用目的の通知、開示、訂正、利用停止等の請求がある場合、弊社は請求があった会員本人もしくは会員の代表者に関するこれらの開示、修正等を行うものとします。なお、開示、訂正等の請求は以下に連絡するものとします。<br />
        連絡先メールアドレス：ask@liberty-resort.jp
      </p>

      <strong>第7条(設備等)</strong>
      <p>
        会員は、本サービスを利用するために必要な通信機器、その他の機器を自己の負担において、準備するものとします。また、自己費用で電気通信サービスを利用してサーバーへ接続するものとします。必要な手続きは会員が自己の責任と費用で行なうものとします。
      </p>

      <strong>第8条(禁止事項)</strong>
      <p>
        1.本サービスの利用に際し、会員は次号に該当する行為を行うことはできません。<br />
        (1)法令又は本規約、公序良俗に反する行為<br />
        (2)第三者の権利、利益を侵害する行為又は第三者の迷惑になる行為<br />
        (3)未成年者に対し悪影響があると判断される行為<br />
        (4)本サービスの運営を妨げ、又は、本サイトもしくは弊社の信用を毀損する行為<br />
        (5)本サービスを通じて入手した情報を私的使用目的以外の方法で利用し、又は第三者に同様の行為をさせる行為（但し、弊社が承認した場合は除く）<br />
        2.会員の行為が前項に該当すると弊社が判断した場合、弊社は会員に対し当該行為の停止を求めることができるほか、会員資格の喪失を決定することができるものとします。
      </p>

      <strong>第9条(会員間の情報)</strong>
      <p>
        1.会員は、自己の責任と良識に従って本サービスを利用するものとし、利用に際して、弊社、第三者に迷惑をかけないものとします。<br />
        2.会員同士でなされた情報の授受、およびそれに付随して行われる行為について弊社は一切責任を負わないものとします。<br />
        3.会員同士あるいは弊社と会員とでなされた情報の授受に関して、当該情報が各種WEB上のウィルス等に感染していたことにより弊社やその他の第三者が損害を蒙った場合、当該情報を掲載した会員はその損害を賠償するものとします。また、本サービスは当該損害について会員または第三者について一切責任を負わないものとします。
      </p>

      <strong>第10条(権利の帰属)</strong>
      <p>
        本サービスを通じて会員から提供された情報や作品その他のコンテンツに関する知的財産権（著作権その他のノウハウ等）は、すべて弊社に帰属するものとします。
      </p>

      <strong>第11条(本サービスの内容の変更および停止)</strong>
      <p>
        弊社は予告なく本サービスの内容の変更、利用停止または中止をすることができるものとします。この変更、停止、中止などについては、本サービスを通じて発表するものとします。この場合に会員または第三者に生じた損害については、弊社はいかなる責任も負わないものとします。
      </p>

      <strong>第12条(一時的な中断)</strong>
      <p>
        弊社は、以下の各号に該当する場合には事前に連絡することなく本サービスを一時的に中断することができるものとします。<br />
        (1)本サイトのシステムの保守、点検、修理、変更を定期的にまたは緊急に行なう場合<br />
        (2)火災、停電などにより提供ができなくなった場合<br />
        (3)地震、噴火、洪水、津波などの天災により提供ができなくなった場合<br />
        (4)戦争、変乱、暴動、騒乱、労働争議などにより提供ができなくなった場合<br />
        (5)その他、運用上、技術上本サービスが一時的な中断を必要と判断した場合
      </p>

      <strong>第13条(本サービスの内容の保証および中断)</strong>
      <p>
        弊社は、本サイトに関して提供する情報、会員が登録する情報について、そのいかなる保証も行ないません。弊社は、理由の如何を問わず、本サイトの提供の遅延または中断などが発生し、その結果会員または他の第三者が損害を被ったとしても当該損害について一切の責任を負わないものとします。
      </p>

      <strong>第14条(損害賠償)</strong>
      <p>
        1.本サービスの利用により発生した会員の損害すべてに対し、弊社はいかなる責任も負わないものとします。損害には第三者による故意のハッキング等により生じた情報漏洩を含みます。また、弊社が会員の登録、掲載した情報を削除し、会員資格を停止し、抹消し、本サービスを停止、中断、中止したことにつき、弊社は事由の如何を問わず、いかなる責任も負わないものとします。<br />
        2.会員が本サービスの利用によって他の会員や第三者に対して損害を与えた場合、会員は自己の責任と費用をもって解決し、弊社に損害を与えることのないものとします。
      </p>

      <strong>第15条(専属的合意管轄裁判所)</strong>
      <p>
        会員と弊社との間で訴訟の必要が生じた場合、静岡地方裁判所もしくは静岡簡易裁判所を専属的合意管轄裁判所とします。
      </p>

      <p>令和2年10月23日制定</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>
<style lang="scss">
.terms_and_conditions {
  max-height: 70vh;
  overflow-y: auto;
  border: 1px solid #cccccc;
  padding: 10px;
}
</style>
